var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyqSearchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 211,
    viewBox: "0 0 360 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5813)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.501,
    cy: 204.001,
    r: 175.88,
    fill: "#F4FAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.502,
    cy: 203.996,
    r: 117.57,
    fill: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.501,
    cy: 203.999,
    r: 82.0775,
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.093 75.1218C199.398 75.2408 214.951 90.9868 214.832 110.291C214.713 129.596 198.967 145.149 179.662 145.03C160.358 144.911 144.805 129.165 144.925 109.86C145.044 90.5557 160.789 75.0028 180.093 75.1218ZM179.704 138.127C195.197 138.223 207.834 125.741 207.93 110.248C208.025 94.7556 195.544 82.1185 180.051 82.023C164.558 81.9275 151.922 94.409 151.826 109.902C151.73 125.395 164.212 138.032 179.704 138.127Z",
    fill: "white",
    stroke: "#9A98E0",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.106 73.1179C199.411 73.2369 214.964 88.9829 214.844 108.287C214.724 127.592 198.979 143.145 179.675 143.025C160.37 142.906 144.817 127.16 144.936 107.856C145.057 88.5518 160.802 72.9989 180.106 73.1179ZM179.718 136.124C195.21 136.219 207.847 123.738 207.943 108.245C208.038 92.7524 195.557 80.1159 180.064 80.0198C164.571 79.9243 151.935 92.4065 151.839 107.899C151.743 123.391 164.225 136.028 179.718 136.124Z",
    fill: "white",
    stroke: "#9A98E0",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.015 174.958L181.483 174.986C182.586 174.993 183.484 174.104 183.491 173.002L183.659 145.825C183.666 144.723 182.778 143.824 181.675 143.817L177.207 143.789C176.104 143.782 175.205 144.671 175.199 145.773L175.031 172.95C175.025 174.052 175.913 174.951 177.015 174.958Z",
    fill: "white",
    stroke: "#9A98E0",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.932 225.271L182.323 225.309C184.732 225.323 186.696 223.382 186.711 220.974L187.042 167.298C187.054 165.415 185.536 163.879 183.654 163.868L175.359 163.816C173.476 163.805 171.94 165.322 171.928 167.205L171.598 220.884C171.583 223.292 173.523 225.256 175.932 225.271Z",
    fill: "#9A98E0",
    stroke: "#9A98E0",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.867,
    cy: 109.245,
    rx: 27.5704,
    ry: 26.6197,
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.275,
    cy: 95.3019,
    rx: 6.02113,
    ry: 5.70423,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.979,
    cy: 105.441,
    rx: 2.85211,
    ry: 2.53521,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.198,
    cy: 65.5147,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.747,
    cy: 199.245,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.269,
    cy: 176.429,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.101,
    cy: 158.046,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.269,
    cy: 117.483,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.325,
    cy: 21.7803,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.79,
    cy: 45.2334,
    r: 1.90141,
    fill: "#BDCBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 210,
    fill: "white",
    transform: "translate(0 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyqSearchLogo);
export default __webpack_public_path__ + "static/media/pyqSearchLogo.10125443548a70de20f9d72b53fb89bd.svg";
export { ForwardRef as ReactComponent };